
export default function WelcomeSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Welcome to CPVA Students
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              The <strong>Students of CPVA</strong> represents the future of integrated healthcare in Canada. We unite pharmacy and veterinary students from across the nation, fostering collaboration between two essential healthcare disciplines.
            </p>
            <p className="text-gray-600 mb-6">
              Our student association promotes the unique One Health approach, recognizing that human health, animal health, and environmental health are interconnected. Through CPVA Students, you'll gain access to exclusive educational opportunities, networking events, and resources that prepare you for a collaborative healthcare future.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Academic Excellence</h3>
                  <p className="text-sm text-gray-600">Support for your educational journey in pharmacy or veterinary medicine</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Professional Networking</h3>
                  <p className="text-sm text-gray-600">Connect with peers and professionals across both disciplines</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Innovation & Research</h3>
                  <p className="text-sm text-gray-600">Engage in cutting-edge research bridging human and animal health</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-hand-heart-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Community Impact</h3>
                  <p className="text-sm text-gray-600">Make a difference in communities through integrated healthcare</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/180d957c11c53a60d31fe02adf0cdaaa.jpg"
              alt="Students collaborating in laboratory"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-lg shadow-lg">
              <div className="text-3xl font-bold">2,500+</div>
              <div className="text-blue-100">Student Members</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
